import config from '../../config';

import { User } from '../../types';

import { getApiKeyClient } from '../client/http';

const {
  apiBaseUrl: { auth: baseUrl },
} = config;

const apiKeyClient = () => getApiKeyClient(baseUrl);

export const checkEmailAvailability = async (email: string) => {
  try {
    const response = await apiKeyClient().post('api/available', { email });
    return response.data.availability;
  } catch (err: any) {
    throw new Error(`Error checking email availability: ${err.message}`);
  }
};

export const verifyEmail = async (userId: string, verificationCode: string) => {
  try {
    const response = await apiKeyClient().get(
      `api/user/${userId}/verify?code=${verificationCode}`,
    );
    return response.status;
  } catch (err: any) {
    throw new Error(`Error verifying email: ${err.message}`);
  }
};

export const verifyResetPwCode = async (userId: string, code: string) => {
  try {
    const response = await apiKeyClient().get(
      `api/user/${userId}/verify-forgot-password/${code}`,
    );

    return response.status;
  } catch (err: any) {
    throw new Error(`Error verifying reset password code: ${err.message}`);
  }
};

export const resetPassword = async (
  userId: string,
  code: string,
  password: string,
) => {
  try {
    const response = await apiKeyClient().post(
      `api/user/${userId}/verify-forgot-password/${code}`,
      { password },
    );

    return response.status;
  } catch (err: any) {
    throw new Error(`Error resetting the password: ${err.message}`);
  }
};

export const createUser = async (data: Partial<User>) => {
  try {
    const response = await apiKeyClient().post('api/user', {
      ...data,
      // TODO: change type to event-owner when API privilege level allows
      roles: [{ type: 'admin', name: null, key: null, value: null }],
    });
    return response.data;
  } catch (err: any) {
    throw new Error(
      `Error creating new user: ${err.response.data.message || err.message}`,
    );
  }
};

export const updateUser = async (userId: string, data: Partial<User>) => {
  try {
    const response = await apiKeyClient().put('api/user', { userId, ...data });
    return response.data;
  } catch (err: any) {
    throw new Error(
      `Error updating new user: ${err.response.data.message || err.message}`,
    );
  }
};

export const getUserData = async (userId: string) => {
  try {
    const response = await apiKeyClient().get(`api/user/${userId}`);
    return response.data.user;
  } catch (err: any) {
    throw new Error(`Error getting user data: ${err.message}`);
  }
};
